<ul>
  <li>{{ value }}</li>
</ul>
